import request from '@/utils/request';
//文件列表
export function filesList(data) {
  return request.post('admin/reminder-document/list', data);
}
//添加文件
export function addFiles(data) {
  return request.post('admin/reminder-document/store', data);
}
//编辑文件
export function editFiles(data) {
  return request.post('admin/reminder-document/edit', data);
}
//文件信息
export function filesInfo(data) {
  return request.post('admin/reminder-document/detail', data);
}
//删除文件
export function delFiles(data) {
  return request.post('admin/reminder-document/delete', data);
}
//修改文件状态
export function filesStatus(data) {
  return request.post('admin/reminder-document/status', data);
}
//文件资源
export function filesResource(data) {
  return request.post('admin/reminder-document/resource', data);
}